declare const sdkHandler: any;

export function playRewardedAd(): Promise<boolean> {
  try {
    if (localStorage.getItem('skipRewardedCallback')) {
      return Promise.resolve(true);
    }
  } catch (e) {
    console.log(e);
  }

  return new Promise((resolve) => {
    sdkHandler.trigger('rewardedAd', {
      callback: (success) => {
        resolve(success);
      },
    });
  });
}
